import { EpicFactory } from "../../../../core/core-redux/reduxTypes";
import { CHANGE_GROUP_PROPERTIES, CHANGE_LAYER_PROPERTIES } from "../../../../common/mapstore/action/layers";
import { VIEW_TYPE_CHANGED } from "../../../../changes/redux/changeWorkspace/updateViewType.action";

import {
    BASELINE_LAYER_GROUP,
    queriableWfs3dBaselineLayerSelector,
    WORKSPACE_LAYER_GROUP,
} from "../../../../common/selector/layerSelector";
import { Action } from "redux";
import { RootState } from "../../../../rootState";
import { BASELINE_VIEW } from "../../../../changes/changesConstants";
import { setWfs3dLayersVisibilityAction } from "./setWfs3dLayersVisibility.action";
import { STORE_WFS_FEATURE_COUNT } from "../count/storeWfsFeatureCount.action";
import { isCesium } from "../../../../../MapStore2/web/client/selectors/maptype";
import { doNothingAction } from "../../../../common/action/doNothingAction";

export const wfs3dLayersVisibilityEpic: EpicFactory<Action, RootState, Action> = (action$, store) =>
    action$
        .ofType(CHANGE_GROUP_PROPERTIES, CHANGE_LAYER_PROPERTIES, VIEW_TYPE_CHANGED, STORE_WFS_FEATURE_COUNT)
        .map((action) => {
            const state = store.getState();
            if (isCesium(state)) {
                const wfsLayers = queriableWfs3dBaselineLayerSelector(state);

                return setWfs3dLayersVisibilityAction(
                    wfsLayers.map((layer: any) => layer.wfs3dLayer),
                    state.changes.workspaceChanges.view === BASELINE_VIEW ? BASELINE_LAYER_GROUP : WORKSPACE_LAYER_GROUP
                );
            } else {
                return doNothingAction();
            }
        });
